import { BranchType } from "../types";
import { ServiceEndpoints } from "../constants";
import { axios } from "./apiConfig";
// import { UpdateBranchPayload } from "hooks/useBranches";

// Fetch all branches
export const getBranches = async () => {
  return axios
    .get(ServiceEndpoints.BRANCHES)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Fetch all branch summary
export const getBranchSummary = async () => {
  return axios
    .get(ServiceEndpoints.BRANCHES_SUMMARY)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Create a new branch
export const createBranch = async (data: { name: string; address: string }) => {
  return axios
    .post(ServiceEndpoints.BRANCHES, data)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Update an existing branch
export const updateBranch = async (id: string | number, data: BranchType) => {
  const { ...branchData } = data;

  return axios
    .put(`${ServiceEndpoints.BRANCHES}/${id}`, branchData)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Get a branch by its ID
export const getBranchById = async (id: string) => {
  return axios
    .get(`${ServiceEndpoints.BRANCHES}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Delete a branch
export const deleteBranch = async (id: string) => {
  return axios
    .delete(`${ServiceEndpoints.BRANCHES}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
